import { Button } from '@/components/ui/Button'
import { Alert } from '@/components/ui/Alert'
import { Skeleton, SkeletonGroup } from '@/components/ui/Skeleton'
import { EmptyState } from '@/components/ui/EmptyState'
import type { Icon as PhosphorIcon } from '@phosphor-icons/react'
import type { ReactNode } from 'react'
import styles from './RequestState.module.css'

type RequestStateProps = {
  kind: 'loading' | 'error' | 'empty'
  title?: string
  onRetry?: () => void
  description?: string
  action?: ReactNode
  icon?: PhosphorIcon
  artwork?: ReactNode
  image?: string
  imageAlt?: string
  density?: 'default' | 'compact'
}

export function RequestState({ kind, title, onRetry, description, action, icon, artwork, image, imageAlt, density }: RequestStateProps) {
  if (kind === 'loading') return <div className={styles.root} role="status" aria-label={title ?? 'در حال دریافت اطلاعات'}>
    <SkeletonGroup count={3} aria-label={title ?? 'در حال دریافت اطلاعات'}><Skeleton height={88} /></SkeletonGroup>
  </div>
  if (kind === 'error') return <div className={styles.root}>
    <Alert>{title ?? 'دریافت اطلاعات انجام نشد. دوباره تلاش کنید.'}</Alert>
    {onRetry && <Button variant="outline" onClick={onRetry}>تلاش مجدد</Button>}
  </div>
  return <EmptyState title={title ?? 'اطلاعاتی برای نمایش وجود ندارد.'} description={description} action={action} icon={icon} artwork={artwork} image={image} imageAlt={imageAlt} density={density} />
}

export function RefreshNotice({ onRetry }: { onRetry: () => void }) {
  return <div className={styles.root} role="alert">
    <span>به‌روزرسانی انجام نشد؛ اطلاعات قبلی نمایش داده می‌شود.</span>
    <Button variant="outline" onClick={onRetry}>تلاش دوباره</Button>
  </div>
}
